<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { elementLocale } from '@/locales/element'
import useSettingsStore from '@/store/modules/settings'
import useExportTasksStore from '@/store/modules/exportTasks'
import { handleThemeStyle } from '@/utils/theme'
import { getToken } from '@/utils/auth'

onMounted(() => {
  if (getToken()) useExportTasksStore().restoreGeneratingTasks()
  nextTick(() => {
    // 初始化主题样式
    // handleThemeStyle(useSettingsStore().theme)
  })
})
</script>
